// Règles des identifiants de connexion (cadrage : docs/CADRAGE-COMPTES-COLLABORATEURS.md §3.5).
// Partagé entre le serveur et les écrans pour que l'aperçu affiché soit exactement l'identifiant créé.
//   - Compte de direction d'un nouvel établissement : `préfixe.direction`
//   - Compte collaborateur : `préfixe.` + un mot choisi par l'établissement
//   - Salarié du portail : `nom.prenom` (règle à part, inchangée)
// Les comptes de direction déjà en production ne sont jamais renommés.

export const SUFFIXE_DIRECTION = 'direction';
/** Mots qu'un collaborateur ne peut pas choisir après le préfixe. */
export const SUFFIXES_RESERVES = [SUFFIXE_DIRECTION, 'admin', 'administrateur', 'support', 'root'];

const sansAccents = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '');

/** « Le Comptoir d'Émeline » → « le-comptoir-d-emeline » (minuscules, chiffres et tirets, 30 caractères au plus). */
export const slugEtablissement = (nom) => sansAccents(nom).toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 30).replace(/-+$/g, '');

export const identifiantDirection = (prefixe) => `${prefixe}.${SUFFIXE_DIRECTION}`;
export const composerIdentifiant = (prefixe, suffixe) => `${prefixe}.${suffixe}`;

/** Le mot choisi par la personne : on retire un éventuel « préfixe. » tapé en entier, puis on met en minuscules. */
export const extraireSuffixe = (prefixe, saisi) => {
    let s = sansAccents(saisi).trim().toLowerCase().replace(/\s+/g, '-');
    const debut = `${String(prefixe || '').toLowerCase()}.`;
    if (prefixe && s.startsWith(debut)) s = s.slice(debut.length);
    return s;
};

/** Message d'erreur en français, ou null si le mot est acceptable. */
export const erreurSuffixe = (suffixe) => {
    if (!suffixe) return 'Choisissez un identifiant.';
    if (!/^[a-z0-9][a-z0-9_-]{1,29}$/.test(suffixe)) return "L'identifiant comporte 2 à 30 caractères : lettres, chiffres, tiret (sans espace ni point).";
    if (SUFFIXES_RESERVES.includes(suffixe)) return `« ${suffixe} » est réservé : choisissez un autre mot.`;
    return null;
};

/** Préfixe tel que les écrans peuvent le prévoir : le début de « xxx.direction », sinon le nom de l'établissement (le serveur reste la référence). */
export const prefixeApparent = (usernameDirection, nomEtablissement) => {
    const u = String(usernameDirection || '').toLowerCase();
    const fin = `.${SUFFIXE_DIRECTION}`;
    return u.endsWith(fin) && u.length > fin.length ? u.slice(0, -fin.length) : slugEtablissement(nomEtablissement);
};
